import React from "react";

export const wrapLinkContent = (content) => {
  const urlRegex = /\b(https?:\/\/[^\s]+)/g;
  //const text = "Text: улица Чингиза Айтматова, 58 Астана https://yandex.ru/navi?whatshere%5Bpoint%5D=71.37350717913684%2C51.157716914725434&whatshere%5Bzoom%5D=16.715677&ll=71.37350717913684%2C51.15771691433038&z=16.715677&si=my3dq82w71a4nb4rf5nzwp5nxg";
  const urlWrappedText = content.replace(urlRegex, (url) => {
    return `<a href="${url}" target="_blank">${url}</a>`;
  });

  return <span dangerouslySetInnerHTML={{ __html: urlWrappedText }} />;
};